import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ThirdPartiesService } from '../../../services/third-parties.service';
import { LoadingService } from '../../../services/loading.service';
import { ToastService } from '../../../services/toast.service';

interface ThirdPartyProfile {
  thirdParty: any;
  financialSummary: any;
  workOrders: any[];
  expenseVouchers: any[];
  creditNotes: any[];
  debitNotes: any[];
}

@Component({
  selector: 'app-profile-third-party',
  templateUrl: './profile-third-party.component.html',
  styleUrl: './profile-third-party.component.scss'
})
export class ProfileThirdPartyComponent implements OnInit {

  thirdPartyId: number = 0;
  profile: ThirdPartyProfile | null = null;
  activeTab: string = 'overview';

  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private thirdPartiesService: ThirdPartiesService,
    private loadingService: LoadingService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.thirdPartyId = +id;
        this.loadThirdPartyProfile();
      } else {
        this.toastService.showToast('error', 'ID del tercero no válido');
        this.router.navigate(['/third-parties']);
      }
    });
  }

  private loadThirdPartyProfile(): void {
    if (this.thirdPartyId <= 0) return;

    this.isLoading = true;
    this.loadingService.show();

    this.thirdPartiesService.getProfile(this.thirdPartyId).subscribe({
      next: (response) => {
        this.profile = response;
        this.isLoading = false;
        this.loadingService.hide();
      },
      error: (error) => {
        console.error('Error loading third party profile:', error);
        this.toastService.showToast('error', 'Error cargando el perfil del tercero');
        this.isLoading = false;
        this.loadingService.hide();
      }
    });
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  isActiveTab(tab: string): boolean {
    return this.activeTab === tab;
  }

  goToEdit(): void {
    this.router.navigate(['/third-partie/view', this.thirdPartyId]);
  }

  goBack(): void {
    this.router.navigate(['/third-parties']);
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP'
    }).format(amount);
  }

  formatDate(date: string): string {
    return new Date(date).toLocaleDateString('es-CO');
  }

  getStatusClass(status: string): string {
    switch (status?.toLowerCase()) {
      case 'pagada':
      case 'completed':
      case 'aprobado':
        return 'bg-green-100 text-green-800';
      case 'pendiente':
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'anulada':
      case 'cancelled':
      case 'rechazado':
        return 'bg-red-100 text-red-800';
      case 'en proceso':
      case 'processing':
        return 'bg-blue-100 text-blue-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  }

  getWorkOrderStatusText(status: string): string {
    switch (status?.toLowerCase()) {
      case '1':
      case 'pendiente':
        return 'Pendiente';
      case '2':
      case 'anulada':
        return 'Anulada';
      case '3':
      case 'pagada':
        return 'Pagada';
      default:
        return status || 'N/A';
    }
  }

  getWorkOrderStatusClass(status: string): string {
    switch (status?.toLowerCase()) {
      case '1':
      case 'pendiente':
        return 'bg-yellow-100 text-yellow-800';
      case '2':
      case 'anulada':
        return 'bg-red-100 text-red-800';
      case '3':
      case 'pagada':
        return 'bg-green-100 text-green-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  }
}